<div class="default-dialog-wrapper mat-elevation-z10">
    <div class="flex flex-col content">
        <div class="flex flex-col justify-between w-100-percent">
            <div class="flex flex-row w-100-percent">
            <h1 class="flex flex-wrap basis-full mat-headline-5 mb-8 fs-24 fw-600 mr-98">{{title | titlecase}}</h1>
            <div class="flex flex-row">
                <button *ngIf="selectedKind.spec.containers.length > 0" class="flex json pt-4 pr-8 pb-4 pl-8 mr-24" (click)="toggleView()">
                  <img src="/assets/images/file_json.svg" *ngIf="!jsonView">
                  <img src="/assets/images/table_view.svg" *ngIf="jsonView">
                  <div class="fs-14 fw-500">
                    {{ (jsonView && selectedKind) ? 'Table View' : ('INSTANCE_DETAILS.JSON' | transloco) }}
                  </div>
                </button>

                <button *ngIf="jsonView && selectedKind && selectedKind.spec.containers.length > 0" class="flex json justify-end pt-4 pr-8 pb-4 pl-8 mr-24"
					[ngClass]="[copy ? 'copied': 'copy']" (click)="copyText()">
					<span *ngIf="!copy" class="fs-16 fw-500 item flex items-center">
						<mat-icon class="h-18 w-18 mr-6" svgIcon="content_copy"></mat-icon>{{ 'ERROR_DIALOG.COPY' |
						transloco }}
					</span>
					<span *ngIf="copy" class="fs-16 fw-500 item flex items-center copied-text">
						<mat-icon class="h-18 w-18 mr-6" svgIcon="check"></mat-icon>{{ 'ERROR_DIALOG.COPIED' | transloco
						}}
					</span>
				</button>

                <mat-icon svgIcon="close" class="cursor-pointer" [matDialogClose]="false"></mat-icon>
              </div>

            </div>
            <div class="fs-16 fw-500" [innerHtml]="message"></div>
        </div>
        <mat-divider class="w-100-percent mt-8 divider-color"></mat-divider>
    </div>
    <div *ngIf="records?.kinds?.length > 0; else noData" class="flex flex-row">
        <div class="flex flex-col pl-24 pr-16">
            <div *ngFor="let kind of records.kinds" (click)="showDetails(kind)" [class.active]="isActive(kind)" class="flex width-container cursor-pointer">
                <span class="flex justify-center ml-8 fs-16 fw-600 items-center">{{ kind.kind }} ({{ kind.spec?.containers?.length ? kind.spec.containers.length : kind.count }})</span>
            </div>
        </div>
        <div class="detail-popup" *ngIf="selectedKind">
            <div class="flex flex-col border-radius route-table mb-16">
                <div *ngIf="!jsonView" class="mb-12 search-scheduler">
                    <app-search-filter *ngIf="selectedKind.spec.containers?.length > 0 && !removeSearch" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
                </div>
                <div *ngIf="selectedKind.spec.containers.length > 0; else anotherTable">
                    <div *ngIf="!jsonView && selectedKind && selectedKind.spec.containers.length > 0" class="table-view">
                        <app-table *ngIf="!jsonView && selectedKind && selectedKind.spec.containers.length > 0" (searchedResults)="searchedItems($event)" [searchTerm]="searchTerm" [initialDataSource]="selectedFilteredKind.spec.containers" [displayColumns]="displayColumns" [showSkeletonLoader]="true" page="kuberentesPopup" [dataSourceLength]="selectedKind.spec.containers?.length > 0" pageName="kuberentesPopup"></app-table>
                    </div>
                    <div *ngIf="jsonView && selectedKind && selectedKind.spec.containers.length > 0" class="w-100-percent json-line-wrapper pl-6">
                        <div class="json-data">
                            <div class="json-line" *ngFor="let line of formattedLines; let i = index">
                                <span class="line-number">{{ i + 1 }}.</span>
                                <span class="line-content">{{ line }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #anotherTable>
                    <div class="table-view">
                        <div class="mb-12 search-scheduler">
                            <app-search-filter *ngIf="selectedKind.count > 0 && !removeSearch" placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
                        </div>
                        <app-table (searchedResults)="searchedItems($event)" [searchTerm]="searchTerm" [initialDataSource]="selectedFilteredKind.name" [displayColumns]="displayColumnsNoSpec" [showSkeletonLoader]="true" page="kuberentesPopupName" [dataSourceLength]="selectedKind.count > 0" pageName="kuberentesPopupName"></app-table>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
    <ng-template #noData>
        <div class="no-data flex flex-col items-center justify-center pt-8 pb-8 fw-600 fs-20 ml-24 mr-24 mb-24 no-data">
            <img class="flex width-height-image" src="/assets/images/image-not-found.png"> <div class="mt-12 no-image">{{'INSTANCE_DETAILS.IMAGE_NOT_AVAILABLE' | transloco }}</div>
        </div>
    </ng-template>
</div>
